<div class="wrapper">
  <app-header></app-header>
  <div class="fullscreen content">
    <div class="p-2 setscreen justify-content-center mt-custom">

      <!-- Left Sidebar -->
      <!-- <div class="col-md-4 d-flex mt-4  justify-content-start " > -->
      <div class="col-md-4 d-none d-md-flex mt-4 justify-content-start">

        <div class="sidebar justify-content-center">
          <div class="leftside">Few steps to post your property</div>

          <div class="step-wrapper">
            <div class="step-line"></div>
            <ul class="step-list">
              <li [class.active]="step === 1"><span class="circle"></span> Basic
                Details</li>
              <li [class.active]="step === 2"><span class="circle"></span>
                Property Details/Price Details</li>
              <li [class.active]="step === 3"><span class="circle"></span>
                Location</li>
              <li [class.active]="step === 4"><span class="circle"></span>
                Images/Videos Details</li>
            </ul>
          </div>

          <div class="progress-container">
            <div class="progress-circle-wrapper">
              <div
                class="progress-circle-foreground"
                [ngStyle]="{ 'background': getConicGradient() }">
              </div>
              <div class="progress-circle-text">{{ progress }}%</div>
            </div>

            <div class="progress-labels">
              <div class="progress-title">Progress score</div>
              <div class="progress-subtitle pl-md-3">Your progress so far</div>
            </div>
          </div>

        </div>
      </div>

      <!-- Right Form Panel -->
      <div class="col-md-6">
        <form [formGroup]="form" (ngSubmit)="submit()">
          <!-- Step 1 -->
          <div class="form-box" *ngIf="step === 1">
            <div class="leftside">Start Renting Out Your Property</div><br>
            <!-- <div class="row">
              <div class="col-md-6">
                <div class="form-section">
                  <label class="labels">Offer to</label>
                        <div class="row">
                    <div class="col-md-6 radio-group">
                      <label>
                        <input type="radio" formControlName="postType"
                          value="Rent"
                          (change)="onOfferChange()" />
                        <span>Rent</span>
                      </label>

                    </div>
                    <div class="col-md-6 radio-group">
                      <label>
                        <input type="radio" formControlName="postType"
                          value="Sell"
                          (change)="onOfferChange()" />
                        <span>Sell</span>
                      </label>
                    </div>
                  </div>

                </div>
              </div>
              <div class="col-md-6"></div>
            </div> -->

            <div class="form-section">
              <label class="labels">Property Type</label>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-6 radio-group">
                      <label><input type="radio" formControlName="type"
                          value="Residential"
                          (change)="resitype()" /><span>Residential</span>
                      </label>

                    </div>
                    <div class="col-md-6 radio-group">
                      <label><input type="radio" formControlName="type"
                          value="Commercial" (change)="resitype()" />
                        <span>Commercial</span> </label>
                    </div>
                  </div>
                </div>
                <div class="col-md-6"></div>

              </div>

            </div>
            <div class="form-section">
              <label class="labels">Condition</label>
              <div class="row">
                <div class="col-md-9">
                  <div class="row">
                    <div class="col-md-4 radio-group">
                      <label style="  margin-right: 10%;"><input type="radio"
                          formControlName="furnishing"
                          value="Furnished"
                          (change)="condition()" /><span>Furnished</span>
                      </label>
                    </div>
                    <div class="col-md-4 radio-group">
                      <label style="  margin-right: 10%;"><input type="radio"
                          formControlName="furnishing"
                          value="semifurnished"
                          (change)="condition()" /><span>Semi
                          Furnished</span> </label>
                    </div>
                    <div class="col-md-4 radio-group">
                      <label style="  margin-right: 10%;"><input type="radio"
                          formControlName="furnishing"
                          value="Unfurnished" (change)="condition()" />
                        <span>Unfurnished</span> </label>
                    </div>
                  </div>
                </div>
                <div class="col-md-3"></div>

              </div>

            </div>
            <!-- Residential Type -->
            <div class="form-section" *ngIf="!isresiSelected">
              <label class="labels mb-4">What do you have?</label>

              <div class="button-group mt-1" *ngIf="!isSellSelected">
                <label class="radio-button">
                  <input type="radio" value="flat/apartment"
                    formControlName="propertyType" name="propertyType" />
                  <span>Flat/Apartment</span>
                </label>

                <label class="radio-button">
                  <input type="radio" value="villa" formControlName="propertyType"
                    name="propertyType" />
                  <span>Villa</span>
                </label>

                <label class="radio-button">
                  <input type="radio" value="independenthouse"
                    formControlName="propertyType" name="propertyType" />
                  <span>Independent House</span>
                </label>

                <label class="radio-button">
                  <input type="radio" value="builderfloor"
                    formControlName="propertyType" name="propertyType" />
                  <span>Builder Floor</span>
                </label>

                <label class="radio-button">
                  <input type="radio" value="other" formControlName="propertyType"
                    name="propertyType" />
                  <span>Other</span>
                </label>
              </div>

              <div class="button-group mt-1" *ngIf="isSellSelected">
                <label class="radio-button">
                  <input type="radio" value="flat/apartment"
                    formControlName="propertyType" name="propertyType" />
                  <span>Flat/Apartment</span>
                </label>

                <label class="radio-button">
                  <input type="radio" value="independenthouse/villa"
                    formControlName="propertyType" name="propertyType" />
                  <span>Independent House/Villa</span>
                </label>

                <label class="radio-button">
                  <input type="radio" value="plot/land"
                    formControlName="propertyType" name="propertyType" />
                  <span>Plot/Land</span>
                </label>

                <label class="radio-button">
                  <input type="radio" value="1rk/studioapartment"
                    formControlName="propertyType" name="propertyType" />
                  <span>1RK/Studio Apartment</span>
                </label>

                <label class="radio-button">
                  <input type="radio" value="independent/builderfloor"
                    formControlName="propertyType" name="propertyType" />
                  <span>Independent/Builder Floor</span>
                </label>

                <label class="radio-button">
                  <input type="radio" value="other" formControlName="propertyType"
                    name="propertyType" />
                  <span>Other</span>
                </label>
              </div>
            </div>

            <!-- Commercial Type -->
            <div class="form-section" *ngIf="isresiSelected">
              <label class="labels mb-4">What do you have?</label>
              <div class="button-group mt-1">
                <label class="radio-button">
                  <input type="radio" value="office-space"
                    formControlName="propertyType" name="propertyType" />
                  <span>Office Space</span>
                </label>

                <label class="radio-button">
                  <input type="radio" value="office-itpark-sez"
                    formControlName="propertyType" name="propertyType" />
                  <span>Office in IT Park/SEZ</span>
                </label>

                <label class="radio-button">
                  <input type="radio" value="shop" formControlName="propertyType"
                    name="propertyType" />
                  <span>Shop</span>
                </label>

                <label class="radio-button">
                  <input type="radio" value="warehouse/godown"
                    formControlName="propertyType" name="propertyType" />
                  <span>Warehouse/Godown</span>
                </label>

                <label class="radio-button">
                  <input type="radio" value="industrialland"
                    formControlName="propertyType" name="propertyType" />
                  <span>Industrial Land</span>
                </label>

                <label class="radio-button">
                  <input type="radio" value="industrialbuilding"
                    formControlName="propertyType" name="propertyType" />
                  <span>Industrial Building</span>
                </label>

                <label class="radio-button">
                  <input type="radio" value="showroom"
                    formControlName="propertyType" name="propertyType" />
                  <span>Showroom</span>
                </label>

                <label class="radio-button">
                  <input type="radio" value="industrialshed"
                    formControlName="propertyType" name="propertyType" />
                  <span>Industrial Shed</span>
                </label>

                <label class="radio-button">
                  <input type="radio" value="other" formControlName="propertyType"
                    name="propertyType" />
                  <span>Other</span>
                </label>
              </div>
            </div>

            <div class="form-section">
              <label class="labels mb-4">Amenities</label>
              <div class="row">

                <div class="col-md-4 mb-2">
                  <div class="form-check">
                    <input type="checkbox" id="security" value="Security"
                      (change)="onAmenityChange($event)"
                      [checked]="amenitiesArray.value.includes('Security')"
                      class="form-check-input" />
                    <label class="form-check-label"
                      for="security">Security</label>
                  </div>
                </div>

                <div class="col-md-4 mb-2">
                  <div class="form-check">
                    <input type="checkbox" id="garden" value="Garden"
                      (change)="onAmenityChange($event)"
                      [checked]="amenitiesArray.value.includes('Garden')"
                      class="form-check-input" />
                    <label class="form-check-label" for="garden">Garden</label>
                  </div>
                </div>

                <div class="col-md-4 mb-2">
                  <div class="form-check">
                    <input type="checkbox" id="gym" value="Gym"
                      (change)="onAmenityChange($event)"
                      [checked]="amenitiesArray.value.includes('Gym')"
                      class="form-check-input" />
                    <label class="form-check-label" for="gym">Gym</label>
                  </div>
                </div>

                <div class="col-md-4 mb-2">
                  <div class="form-check">
                    <input type="checkbox" id="guestSuite" value="Guest Suite"
                      (change)="onAmenityChange($event)"
                      [checked]="amenitiesArray.value.includes('Guest Suite')"
                      class="form-check-input" />
                    <label class="form-check-label" for="guestSuite">Guest
                      Suite</label>
                  </div>
                </div>

                <div class="col-md-4 mb-2">
                  <div class="form-check">
                    <input type="checkbox" id="banquetHall" value="Banquet Hall"
                      (change)="onAmenityChange($event)"
                      [checked]="amenitiesArray.value.includes('Banquet Hall')"
                      class="form-check-input" />
                    <label class="form-check-label" for="banquetHall">Banquet
                      Hall</label>
                  </div>
                </div>

                <div class="col-md-4 mb-2">
                  <div class="form-check">
                    <input type="checkbox" id="meetingRoom" value="Meeting Room"
                      (change)="onAmenityChange($event)"
                      [checked]="amenitiesArray.value.includes('Meeting Room')"
                      class="form-check-input" />
                    <label class="form-check-label" for="meetingRoom">Meeting
                      Room</label>
                  </div>
                </div>

                <div class="col-md-4 mb-2">
                  <div class="form-check">
                    <input type="checkbox" id="musicRoom" value="Music Room"
                      (change)="onAmenityChange($event)"
                      [checked]="amenitiesArray.value.includes('Music Room')"
                      class="form-check-input" />
                    <label class="form-check-label" for="musicRoom">Music
                      Room</label>
                  </div>
                </div>

                <div class="col-md-4 mb-2">
                  <div class="form-check">
                    <input type="checkbox" id="swimmingPool"
                      value="Swimming Pool" (change)="onAmenityChange($event)"
                      [checked]="amenitiesArray.value.includes('Swimming Pool')"
                      class="form-check-input" />
                    <label class="form-check-label" for="swimmingPool">Swimming
                      Pool</label>
                  </div>
                </div>

                <div class="col-md-4 mb-2">
                  <div class="form-check">
                    <input type="checkbox" id="pool" value="Pool"
                      (change)="onAmenityChange($event)"
                      [checked]="amenitiesArray.value.includes('Pool')"
                      class="form-check-input" />
                    <label class="form-check-label" for="pool">Pool</label>
                  </div>
                </div>

                <div class="col-md-4 mb-2">
                  <div class="form-check">
                    <input type="checkbox" id="gameRoom" value="Game Room"
                      (change)="onAmenityChange($event)"
                      [checked]="amenitiesArray.value.includes('Game Room')"
                      class="form-check-input" />
                    <label class="form-check-label" for="gameRoom">Game
                      Room</label>
                  </div>
                </div>

                <div class="col-md-8 mb-2">
                  <div class="form-check">
                    <input type="checkbox" id="studyRoom" value="Study Room"
                      (change)="onAmenityChange($event)"
                      [checked]="amenitiesArray.value.includes('Study Room')"
                      class="form-check-input" />
                    <label class="form-check-label" for="studyRoom">Study
                      Room</label>
                  </div>
                </div>

              </div>

            </div>

            <div class="row d-flex justify-content-center">
              <button class="continue-btn setbutton" type="button"
                (click)="nextStep()">Continue</button>
            </div>

          </div>

          <!-- Step 2 -->
          <div class="form-box mt-3" *ngIf="step === 2">
            <div class="leftside">Lets understand your property</div><br>
            <div class="form-section">
              <label class="labels">Property Title</label><br>
              <input type="text" formControlName="title"
                placeholder="Enter Property title"
                style="border-radius: 15px;" />
              <div class="text-danger"
                *ngIf="form.get('title')?.touched && form.get('title')?.hasError('required')">
                Property Title is required.
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12">
                <div class="form-section">
                  <label class="labels">Property Description</label><br>
                  <div class style="gap: 8px;">
                    <textarea
                      formControlName="description"
                      placeholder="Enter Property Description"
                      style="border-radius: 15px; height: 150px; max-height: 300px; padding: 15px; width: 100%;"></textarea>
                    <div class="text-danger"
                      *ngIf="form.get('description')?.touched && form.get('description')?.hasError('required')">
                      Property Description is required.
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-section">
                  <label class="labels">Super Built-Up Area</label><br>
                  <div class style="gap: 8px;">
                    <input type="text" formControlName="buildupArea" (input)="onInput($event)"
                      placeholder="Enter Super Built-Up Area (Sqft)"
                      style=" border-radius: 15px;" />
                    <div class="text-danger"
                      *ngIf="form.get('buildupArea')?.touched && form.get('buildupArea')?.hasError('required')">
                      Super Built-Up Area is required.
                    </div>
                  </div>
                </div>

              </div>
              <div class="col-md-6">
                <div class="form-section">
                  <label class="labels">Cover Area</label><br>
                  <div class style="gap: 8px;">
                    <input type="text" formControlName="coverArea" (input)="onInput($event)"
                      placeholder="Enter Cover Area (Sqft)"
                      style=" border-radius: 15px;" />
                    <div class="text-danger"
                      *ngIf="form.get('coverArea')?.touched && form.get('coverArea')?.hasError('required')">
                      Cover Area is required.
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div class="row mt-3">
              <div class="col-md-6">

                <div class="form-section">
                  <label class="labels">Age Of Construction</label><br>
                  <ng-select [items]="ageOptions"
                    bindLabel="label"
                    bindValue="value"
                    placeholder="Select Age"
                    formControlName="construction">
                  </ng-select>
                </div>

              </div>
              <div class="col-md-6">
                <div class="form-section">
                  <label class="labels mb-2">Parking</label>
                  <div class="form-section">
                    <div class="radio-group d-flex" style="gap: 20px;">
                      <label>
                        <input type="radio"
                          formControlName="widthOfFacingRoadUnit"
                          value="Dedicated"
                          />
                        <span>Dedicated</span>
                      </label>
                      <label>
                        <input type="radio"
                          formControlName="widthOfFacingRoadUnit" value="Open"
                          />
                        <span>Open</span>
                      </label>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-md-6"> <div class="form-section">
                  <label class="labels">Floor </label><br>
                  <ng-select [items]="floorOptions"
                    bindLabel="label"
                    bindValue="value"
                    placeholder="Select Floor"
                    formControlName="totalFloors">
                  </ng-select>

                </div></div>
              <div class="col-md-6"> <div class="form-section">
                  <label class="labels">Water Supply </label><br>
                  <ng-select
                    [items]="waterSupplyOptions"
                    bindLabel="label"
                    bindValue="value"
                    placeholder="Select Water Supply"
                    formControlName="waterSource">
                  </ng-select>

                </div></div>
            </div>

            <div class="d-flex justify-content-center mt-4" style="gap: 20px;">
              <button class="continue-btn setbutton" type="button"
                (click)="prevStep()">Back</button>
              <button class="continue-btn setbutton" type="button"
                (click)="nextStep()">Continue</button>
            </div>

          </div>

          <!-- Step 3 -->
          <div class="form-boxthird" *ngIf="step === 3">
            <div class="leftside">What is your property address?</div><br>
            <div class="row mt-3">
              <div class="col-md-6">
                <div class="form-section">
                  <label class="labels">Rental Property Address</label>
                  <input type="text" formControlName="address"
                    placeholder="Enter Address"
                    style="border-radius: 15px;" />
                  <div class="text-danger"
                    *ngIf="form.get('address')?.touched && form.get('address')?.hasError('required')">
                    Rental Property Address is required.
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-section">
                  <label class="labels">Locality</label>
                  <input type="text" formControlName="area"
                    placeholder="Enter Locality"
                    style=" border-radius: 15px;" />
                </div>
              </div>

            </div>
            <div class="row mt-3">
              <div class="col-md-6">
                <div class="form-section">
                  <label class="labels">City</label><br>
                  <!-- City Dropdown -->
                  <ng-select
                    [items]="cityDataList"
                    bindLabel="name"
                    bindValue="id"
                    [searchable]="true"
                    placeholder="Select Your City"
                    [formControlName]="'cityId'"
                    (search)="onSearchCity($event)"
                    (change)="onCitySelected($event)">
                  </ng-select>
                  <div class="text-danger"
                    *ngIf="form.get('cityId')?.touched && form.get('cityId')?.hasError('required')">
                    City is required.
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-section">
                  <label class="labels">State</label><br>

                  <ng-select
                    [items]="stateList"
                    bindLabel="stateName"
                    bindValue="stateId"
                    formControlName="stateId"
                    [searchable]="false"
                    [formControlName]="'stateId'"
                    [clearable]="false">
                  </ng-select>

                </div>
              </div>

            </div><br><br>
            <div class="leftside">What is your expected Price?</div><br><br>
            <div class="row ">
              <div class="col-md-6">
                <label class="labels">Price Details</label><br>
                <!-- <div class="pd-box">
                  <select class="pd-symbol" formControlName="currencyasking">
                    <option value="INR">₹ (INR)</option>
                    <option value="AUD">$ (AUD)</option>
                    <option value="AED">د.إ (AED)</option>
                    <option value="USD">$ (USD)</option>
                    <option value="EUR">€ (EUR)</option>
                    <option value="GBP">£ (GBP)</option>
                    <option value="BDT">৳ (BDT)</option>
                    <option value="NPR">₨ (NPR)</option>
                    <option value="LKR">Rs (LKR)</option>
                    <option value="PKR">₨ (PKR)</option>
                  </select>
                  <div *ngIf="!isSellSelected">
                    <input
                      type="text"
                      placeholder="Enter Rent/Month"
                      formControlName="rentPerMonth"
                      class="pd-input" style="border: none;" />
                  </div>
                  <div *ngIf="isSellSelected">

                    <input
                      type="text"
                      placeholder="Enter Property Price"
                      formControlName="rentPerMonth"
                      class="pd-input" style="border: none;" />
                  </div>

                </div> -->

                <div class="d-flex align-items-center gap-2">

                  <ng-select
                    class="mobile-code-select"
                    placeholder="₹ INR"
                    [clearable]="false"
                    [searchable]="false"
                    [disabled]="true"
                    style="min-width: 100px;">
                  </ng-select>
                  <div *ngIf="!isSellSelected"> <input
                      type="text"
                      class="form-control mobile-number-input"
                      formControlName="propertyRentPrice"
                      placeholder="Enter Rent/Month " (input)="onInput($event)" /></div>
                  <!-- propertyRentPrice -->
                  <div *ngIf="isSellSelected"> <input
                      type="text"
                      class="form-control mobile-number-input"
                      formControlName="asking"
                      placeholder="Enter Property Price" /></div>

                </div>
              </div>
              <div class="col-md-6 manitname">
                <div *ngIf="!isSellSelected">
                <label class="labels">Maintenance Charge</label><br>


                <div class="d-flex align-items-center gap-2">

                  <ng-select
                    class="mobile-code-select"
                    placeholder="₹ INR"
                    [clearable]="false"
                    [searchable]="false"
                    [disabled]="true"
                    style="min-width: 100px;">
                  </ng-select>

                  <input
                    type="text"
                    class="form-control mobile-number-input"
                    formControlName="maintenanceCharge"
                    placeholder="Amount" (input)="onInput($event)" />
                </div>
              </div>
              </div>
            </div>

            <div class="d-flex justify-content-center mt-4" style="gap: 20px;">
              <button class="continue-btn setbutton" type="button"
                (click)="prevStep()">Back</button>
              <button class="continue-btn setbutton" type="button"
                (click)="nextStep()">Continue</button>
            </div>
          </div>

          <!-- Step 4 -->
          <div class="form-box" *ngIf="step === 4">
            <div class="leftside">Add images/videos</div>
            <div class="form-section">
              <div class="media-upload-section">
                <label class="labels">Images</label>
                <div class="media-upload-box">
                  <div class="upload-box-wrapper">

                    <!-- "See all" Thumbnail -->
                    <div
                      class="thumbnail-box"
                      *ngIf="uploadedImages.length > 0 && !showGallery"
                      (click)="showGallery = true">
                      <img [src]="uploadedImages[0]" alt="Thumbnail" />
                      <div class="see-all-overlay">See all</div>
                    </div>

                    <!-- Upload Box (only when gallery is not shown) -->
                    <div class="upload-box" *ngIf="!showGallery">
                      <div
                        class="d-flex justify-content-center media-upload-icon"
                        (click)="triggerFileInput()">
                        <i class="fa fa-picture-o" aria-hidden="true"></i>
                      </div>
                      <span class="drag">Upload or drag your property images
                        here</span>
                      <div class="media-upload-link setbutton"
                        (click)="triggerFileInput()">
                        Upload <i class="fa fa-cloud-upload"
                          aria-hidden="true"></i>
                      </div>
                      <input
                        type="file"
                        id="fileInput"
                        formControlName="imageUrls"
                        (change)="handleChange($event)"
                        name="fileInput"
                        accept="image/*"
                        multiple
                        hidden />
                    </div>

                    <!-- Gallery (replaces upload box) -->
                    <div class="image-gallery"
                      *ngIf="showGallery && uploadedImages.length > 0">
                      <div class="gallery-nav prev"
                        (click)="scrollGallery(-1)">&lt;</div>

                      <div
                        class="gallery-scroll"
                        [class.with-scrollbar]="uploadedImages.length > 4"
                        #galleryScroll>
                        <div
                          *ngFor="let imageUrl of uploadedImages; let i = index"
                          class="gallery-image">
                          <img
                            [src]="imageUrl"
                            alt="Uploaded Image"
                            (click)="openFullscreen(i)" />
                          <div
                            class="remove-btn"
                            (click)="removeImage(i); $event.stopPropagation()"
                            aria-label="Remove Image"
                            title="Remove Image">&times;</div>
                        </div>
                      </div>

                      <div class="gallery-nav next"
                        (click)="scrollGallery(1)">&gt;</div>
                      <div class="close-gallery" (click)="showGallery = false">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>

                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Fullscreen modal -->
              <div class="fullscreen-overlay" *ngIf="showFullscreen">
                <div class="fullscreen-close"
                  (click)="closeFullscreen()">&times;</div>

                <div
                  class="fullscreen-nav prev"
                  (click)="prevFullscreenImage()"
                  [class.disabled]="fullscreenIndex === 0"
                  aria-label="Previous Image">&lt;</div>

                <div class="fullscreen-image-container">
                  <img
                    [src]="uploadedImages[fullscreenIndex]"
                    alt="Fullscreen Image"
                    class="fullscreen-image" />
                  <!-- <div
                    class="fullscreen-remove-btn"
                    (click)="removeImage(fullscreenIndex)"
                    aria-label="Remove Image"
                    title="Remove Image">&times;</div> -->
                </div>

                <div
                  class="fullscreen-nav next"
                  (click)="nextFullscreenImage()"
                  [class.disabled]="fullscreenIndex === uploadedImages.length - 1"
                  aria-label="Next Image">&gt;</div>
              </div>

            <!-- Upload Video -->

            <div class="form-section">
              <div class="media-upload-section">
                <label class="labels">Upload a video</label>
                <div class="media-upload-box">
                  <div class="upload-box-wrapper">

                    <!-- See all thumbnail -->
                    <div
                      class="thumbnail-box"
                      *ngIf="VediouploadedImages.length > 0 && !showVideoGallery"
                      (click)="showVideoGallery = true">
                      <video [src]="VediouploadedImages[0]" muted width="200"
                        height="120"></video>
                      <div class="see-all-overlay">See all</div>
                    </div>

                    <!-- Upload box -->
                    <div class="upload-box" *ngIf="!showVideoGallery">
                      <div
                        class="d-flex justify-content-center media-upload-icon"
                        (click)="VediotriggerFileInput()">
                        <i class="fa fa-video-camera" aria-hidden="true"></i>
                      </div>
                      <span class="drag">Upload or drag your property videos
                        here</span>
                      <div class="media-upload-link setbutton"
                        (click)="VediotriggerFileInput()"
                        [class.disabled]="VediouploadedImages.length >= 3">
                        Upload <i class="fa fa-cloud-upload"
                          aria-hidden="true"></i>
                      </div>
                      <input
                        type="file"
                        id="vediofileInput"
                        formControlName="videoUrls"
                        (change)="VediohandleChange($event)"
                        name="fileInput"
                        accept="video/*"
                        multiple
                        hidden />
                    </div>

                    <!-- Video gallery -->
                    <div class="image-gallery"
                      *ngIf="showVideoGallery && VediouploadedImages.length > 0">
                      <div class="gallery-nav prev"
                        (click)="scrollVideoGallery(-1)">&lt;</div>

                      <div class="gallery-scroll"
                        [class.with-scrollbar]="VediouploadedImages.length > 3"
                        #videoGalleryScroll>
                        <div
                          *ngFor="let videoUrl of VediouploadedImages; let i = index"
                          class="gallery-image">
                          <video
                            [src]="videoUrl"
                            width="200"
                            height="120"
                            muted
                            (click)="openVideoFullscreen(i)">
                          </video>
                          <div class="remove-btn"
                            (click)="VedioremoveImage(i); $event.stopPropagation()"
                            aria-label="Remove Video"
                            title="Remove Video">&times;</div>
                        </div>
                      </div>

                      <div class="gallery-nav next"
                        (click)="scrollVideoGallery(1)">&gt;</div>
                      <div class="close-gallery"
                        (click)="showVideoGallery = false">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <!-- Fullscreen video modal -->
            <div class="fullscreen-overlay" *ngIf="showVideoFullscreen">
              <div class="fullscreen-close"
                (click)="closeVideoFullscreen()">&times;</div>

              <div class="fullscreen-nav prev"
                (click)="prevFullscreenVideo()"
                [class.disabled]="videoFullscreenIndex === 0">&lt;</div>

              <div class="fullscreen-image-container">
                <video
                  [src]="VediouploadedImages[videoFullscreenIndex]"
                  controls
                  autoplay
                  width="100%"
                  height="auto"
                  class="fullscreen-image">
                </video>
              </div>

              <div class="fullscreen-nav next"
                (click)="nextFullscreenVideo()"
                [class.disabled]="videoFullscreenIndex === VediouploadedImages.length - 1">&gt;</div>
            </div>

            <div class="d-flex justify-content-center" style="gap: 20px;">
              <button class="continue-btn setbutton" type="button"
                (click)="prevStep()">Back</button>
              <!-- <button class="continue-btn" type="submit"
                [disabled]="uploadedImages.length === 0 && VediouploadedImages.length === 0">Submit</button> -->
              <button class="continue-btn setbutton" type="submit"
                >Submit</button>
            </div>

          </div>
        </form>
      </div>
    </div>
    <br><br>

  </div>
  <app-footer></app-footer>
</div>

<ng-template #emailDialog>
  <mat-dialog-content>
    <div class="first-row">
      <span class="title">Enter Your Email</span>
      <div class="close-container">
        <button class="close-button " (click)="dialogRef.close()">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>

    <div class="otp-card">
<input
  type="email"
  [(ngModel)]="email"
  name="email"
  required
  email
  #emailInput="ngModel"
  placeholder="Enter your email"
  class="form-control"
  style="border: 1px solid #004aad; border-radius: 15px ; padding: 3px 30px 0px 10px;"
/>

<!-- 🔔 Show errors after submit attempt -->
<div class="text-dangers mt-1" *ngIf="emailInput.invalid && (submitted || emailInput.touched)">
  <small *ngIf="emailInput.errors?.['required']">Email is required.</small>
  <small *ngIf="emailInput.errors?.['email']">Please enter a valid email address.</small>
</div>


      <div class="button-container mt-2">
        <button mat-raised-button color="primary" class="setbutton" (click)="sendOtp()">Send OTP</button>
      </div>
    </div>
  </mat-dialog-content>
</ng-template>


<ng-template #otpDialog>
  <mat-dialog-content>
    <div class="first-row">
      <span class="title">Enter OTP</span>
      <div class="close-container">
        <button class="close-button" (click)="dialogRef.close()">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>

    <div class="otp-cards">
      <p class="p4">OTP sent to <strong>{{ email }}</strong></p>
      <div class="form-group">
        <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="otpConfig"></ng-otp-input>
      </div>
      <div class="button-container mt-2">
        <button mat-raised-button color="primary" class="setbutton" (click)="verifySubmit()">Submit</button>
      </div>
    </div>
  </mat-dialog-content>
</ng-template>

